import axios from 'axios';
import { HOLD_WIP_SERVER_URL, UNSECURE_SERVER_URL } from '../../config/env';


export default class TicketService {

    static getServerUrl() {
        return HOLD_WIP_SERVER_URL;
    }

    static getUnsecureServerUrl() {
        return UNSECURE_SERVER_URL;
    }

    /*********
     * HOLD TICKETS
     * */

    static createHoldTicket( ticketJSON ){
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/createHoldTicket",
            data: ticketJSON,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static saveHoldActionItems ( actionJSON ) {
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/saveHoldActionItems",
            data: actionJSON,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static closeHoldTicket ( holdTicketJSON ) {
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/closeHoldTicket",
            data: holdTicketJSON,
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }

    static updateHoldTicket( ticketJSON ) {
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/updateHoldTicket",
            data: ticketJSON,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static getHoldTickets(){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/holdTickets",
        });
    }

    static getHoldTicketsBySearch( searchJSON ){
        return axios({
            method:'post',
            url:HOLD_WIP_SERVER_URL + "/searchHold",
            data: searchJSON,
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static getMaterialData( materialNo ){
        return axios({
            method:'get',
            url:HOLD_WIP_SERVER_URL + "/getMaterialData/" + materialNo,
        });
    }

    static generateHoldExcelReport ( searchJSON ) {
        return axios ({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/generateHoldExcelReport",
            responseType: 'text/plain',
            data: searchJSON,
            headers: {
                'Content-Type': "application/json"
            },
        })
    }

    static getHoldTicketById( ticketId ){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/getHoldTicketById",
            params: { ticketId: ticketId }
        });
    }

    static getDefects(){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/getAllDefects"
        });
    }

    static getDispositions(){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/getAllDispositions"
        });
    }

    static getPlants(){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/getAllPlants"
        });
    }

    static getHoldStatuses(){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/getHoldStatuses"
        });
    }

    static getWipStatuses(){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/getWipStatuses"
        });
    }

    static countHoldTickets() {
        return axios({
            method: 'get',
            url: HOLD_WIP_SERVER_URL + "/countHoldTickets",
        });
    }

    static saveHoldAttachment( formData ) {
        return axios.post(HOLD_WIP_SERVER_URL + "/saveHoldAttachment", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static getHoldAttachments( holdTicketId ) {
        return axios({
            method: 'get',
            url: HOLD_WIP_SERVER_URL + "/getHoldAttachments",
            params: { ticketId: holdTicketId }
        })
    }

    static deleteHoldAttachment( attachmentId ) {
        return axios({
            method: 'get',
            url: HOLD_WIP_SERVER_URL + "/deleteHoldAttachment",
            params: { attachmentId: attachmentId }
        })
    }


    /*******
     * WIP TICKETS
     */

    static countWipTickets() {
        return axios({
            method: 'get',
            url: HOLD_WIP_SERVER_URL + "/countWipTickets",
        });
    }

    static getWipTickets(){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/wipTickets",
        });
    }

    static getWipTicketById( ticketId ){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/getWipTicketById",
            params: { ticketId: ticketId }
        });
    }
    static getDiscrepancies(){
        return axios({
            method:'get',
            url: HOLD_WIP_SERVER_URL + "/getAllDiscrepancies"
        });
    }

    static createWipTicket( ticketJSON ){
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/createWipTicket",
            data: ticketJSON,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static updateWipTicket( ticketJSON ) {
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/updateWipTicket",
            data: ticketJSON,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static saveWipActionItems ( actionJSON ) {
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/saveWipActionItems",
            data: actionJSON,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static closeWipTicket ( wipTicketJSON ) {
        return axios({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/closeWipTicket",
            data: wipTicketJSON,
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }

    static saveWipAttachment( formData ) {
        return axios.post(HOLD_WIP_SERVER_URL + "/saveWipAttachment", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static generateWipExcelReport ( searchJSON ) {
        return axios ({
            method: 'post',
            url: HOLD_WIP_SERVER_URL + "/generateWipExcelReport",
            responseType: 'text/plain',
            data: searchJSON,
            headers: {
                'Content-Type': "application/json"
            },
        })
    }

    static getWipTicketAttachments( wipTicketId ) {
        return axios({
            method: 'get',
            url: HOLD_WIP_SERVER_URL + "/getWipAttachments",
            params: { ticketId: wipTicketId }
        })
    }

    static deleteWipAttachmentById( attachmentId ) {
        return axios({
            method: 'get',
            url: HOLD_WIP_SERVER_URL + "/deleteWipAttachment",
            params: { attachmentId: attachmentId }
        })
    }

    static getWipTicketsBySearch( searchJSON ){
        return axios({
            method:'post',
            url:HOLD_WIP_SERVER_URL + "/searchWip",
            data: searchJSON,
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

}